module.exports = __webpack_public_path__ + "d1987d78f639312cd82cbc907b011a2b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/helpers/images/milestoneImage/background-orange.svg
// module id = ./src/helpers/images/milestoneImage/background-orange.svg
// module chunks = 4